module.exports = __webpack_public_path__ + "static/img/Pierre-Mauroy-Stadium.2733fc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Pierre-Mauroy-Stadium.jpg
// module id = znM9
// module chunks = 0